export default "__VITE_ASSET__c51bd048__"